import { makeStyles } from '@material-ui/core';

export const useCompleteOrderStyles = makeStyles(theme => ({
  root: {
    display      : 'flex',
    alignItems   : 'flex-end',
    margin       : theme.spacing(2, 0, 1),
    flexDirection: 'column',
    gap          : theme.spacing(3),
  },
  priceContainer: {
    width         : '100%',
    display       : 'flex',
    justifyContent: 'flex-end',
    gap           : theme.spacing(3),
    border        : '1px solid',
    borderLeft    : '0',
    borderRight   : '0',
    borderColor   : theme.palette.grey.light,
    padding       : theme.spacing(3, 0),
    fontSize      : '16px',
    alignItems    : 'center',
  },
  priceText: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize  : '24px',
  },
}));
